module.exports = __webpack_public_path__ + "img/home_collections_it.5e29f29.png";